//full screen image block
const ImageBlock = ({data})  => {

    return(
        <>
        <section className="image_block">
            <div className="container">
                <div className="row align-items-center text-center-xs">
                    <div className="col-12 col-lg-12">
                        <img className="img-fluid" src={data.imageUrl} />
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default ImageBlock;